<template>
	<div>
		<div style="display: flex; flex-direction: column; flex: 1; height: 50vh; width: 50vw;">
			<ejs-grid ref="grid" height="100%" width="100%" :sortSettings="sortSettings" :selectionSettings="selectionOptions" :allowTextWrap="false" :textWrapSettings="wrapSettings" :dataBound="dataBound" :dataSource="softHistory" :allowPaging="true" :pageSettings="pageSettings" :allowFiltering="true" :filterSettings="filterOptions" :allowSorting="true" :allowMultiSorting='true' :showBusyIndicator="true" style="position: relative">
				<e-columns>
					<e-column field="date" :headerText="$t('UpdateDate')" textAlign="Left" :customAttributes="customAttributes" type="datetime" :format="dateTimeFormatOptions"></e-column>
					<e-column field="fieldName" :headerText=" $t('FieldName')" textAlign="Left" :customAttributes="customAttributes"></e-column>
					<e-column field="value" :headerText=" $t('Value')" textAlign="Left" :customAttributes="customAttributes"></e-column>
				</e-columns>
			</ejs-grid>
		</div>
	</div>
</template>

<script>
import { getSoftwareHistoryForDevice } from '@api'
import {CommandColumn, ExcelExport, Filter, Page, PdfExport, Search, Sort, Toolbar} from "@syncfusion/ej2-vue-grids";

export default {
	name: "DevicesSoftwareHistoryModal",
	provide: {
		grid: [ Sort, Page, Filter, Toolbar, Search, CommandColumn, PdfExport, ExcelExport ]
	},
	props: {
		device: {
			type: Object,
			required: true,
		}
	},
	data() {
		return {
			softHistory: [],
			pageSettings: { pageSize: 100, pageSizes: [10, 25, 50, 100] },
			sortSettings: {
				columns: [
					{ field: 'date', direction: 'Descending' }
				]
			},
			dateTimeFormatOptions: { format: 'yyyy-MM-dd HH:mm:ss', type:'dateTime'},
			wrapSettings: { wrapMode: "Content" },
			selectionOptions: { type: "Multiple" },
			filterOptions: {
				type: "Menu",
			},
			customAttributes: { class: "customcss" },
		}
	},
	methods: {
		async getData() {
			this.softHistory = await getSoftwareHistoryForDevice(this.device.id);
		},
		dataBound: function () {
			this.$refs.grid.autoFitColumns();
		},
	},
	mounted: async function() {
		await this.getData();
	}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Systems/Devices/DevicesSoftwareHistoryModal.vue